module.exports = __webpack_public_path__ + "img/a89549c.png";